import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities, ResponsiveUtilities } from '../utils';
import formSsoSignup from '../form-sso-signup';
import fchatFormHandler from './fchat-form-handlers';
// import fsalesFormHandler from './fsales-form-handlers';
// import fmarketerFormHandler from './fmarketer-form-handlers';
import fcallerFormHandler from './fcaller-form-handlers';
import fdeskFormHandler from './fdesk-form-handlers';
import fpingFormHandler from './fping-form-handlers';
import fworksFormHandler from './fworks-form-handlers';
import fstatusFormHandler from './fstatus-form-handlers';
import fteamFormHandler from './fteam-form-handlers';
import fwCrmFormHandler from './fwcrm-form-handlers';
import fsurveyFormHandler from './fsurvey-form-handlers';
import fwcssuiteFormHandlers from './fwcssuite-form-handlers';
import GA4Utilities from '../utils/ga4-utilities';
const { fchatSignupFormSuccess } = fchatFormHandler;
// const { fsalesSignupFormSuccess } = fsalesFormHandler;
// const { fmarketerSignupFormSuccess } = fmarketerFormHandler;
const { fcallerSignupFormSuccess } = fcallerFormHandler;
const { fdeskSignupFormSuccess } = fdeskFormHandler;
const { fpingSignupFormSuccess } = fpingFormHandler;
const { fworksCrmSignupForm, fworksCrmSignupFormSuccess } = fworksFormHandler;
const { fstatusSignupFormSuccess } = fstatusFormHandler;
const { fteamSignupFormSuccess } = fteamFormHandler;
const { fwCrmSignupForm, fwCrmSignupFormSuccess } = fwCrmFormHandler;
const { fsurveySignupFormSuccess } = fsurveyFormHandler;
const { fwcssuiteSignupFormSuccess } = fwcssuiteFormHandlers;
const { handleGoogleSingupErrHandler } = formSsoSignup;
const channelInfo = SiteUtilities.channelInfo();

const getCollectorPayload = (obj, $form) => {
  const product = $form.data('product');
  const prod = {
    fchat: 'Freshchat',
    fcaller: 'Freshcaller',
    fdesk: 'Freshdesk',
    fping: 'Freshping',
    fteam: 'Freshteam',
    fsurvey: 'Freshsurvey',
    fsales: 'Freshsales',
    fmarketer: 'Freshmarketer',
    fwcrm: 'FW CRM',
    fwcssuite: 'Freshworks Customer Service Suite'
  }[product] || '';
  if (prod) obj.freshmarketerObject['product'] = prod;
  switch (product) {
    case 'fchat':
      if ($form.hasClass('freshchat-whatsapp-signup')) {
        obj.freshmarketerObject.custom_field.cf_website = $form.find('.website-form').val() || '';
        obj.freshmarketerObject.custom_field.cf_fchatnumberofemployees = $form.find('.employees-field').val() || '';
      }
      break;
    case 'fdesk':
      obj.freshmarketerObject.custom_field['cf_fdesklastreferrer'] = Cookie.get('fw_flu') || '';
      obj.freshmarketerObject.custom_field['cf_fdesksignupreferrer'] = window.location.href || '';
      obj.freshmarketerObject.custom_field['cf_signupdevice'] = ResponsiveUtilities.getDeviceType();
      obj.freshmarketerObject.custom_field['cf_department'] = $form.find('.department-form').val() || '';
      obj.freshmarketerObject.custom_field['cf_joblevel'] = $form.find('.job-level-form').val() || '';
      const email = $form.find('input[name^="email"]').val() || null;
      const isBusinessEmail = SiteUtilities.isBusinessEmail(email);
      if (!isBusinessEmail) {
        obj.freshmarketerObject.custom_field['cf_leadspaceindustry'] = $form.find('.company-industry-form').val() || '';
        obj.freshmarketerObject.custom_field['cf_website'] = $form.find('.website-form').val() || '';
      }
      break;
    case 'fsales':
    case 'fwcrm':
      const geoLocation = LocationUtilities.getGeoLocation();
      if (product === 'fwcrm') {
        const subProduct = $form.data('sub_product') || null;
        if (subProduct) {
          obj.freshmarketerObject.custom_field['cf_subproduct'] = subProduct;
        }
      }
      obj.freshmarketerObject.custom_field['cf_fsalesfirstreferrer'] = Cookie.get('fw_flu') || '';
      obj.freshmarketerObject.custom_field['cf_fsalessignupreferrer'] = window.location.href || '';
      obj.freshmarketerObject.custom_field['cf_fsalescustomerstatus'] = 'Trial';
      try {
        if (geoLocation) {
          if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
            obj.freshmarketerObject['country'] = geoLocation.countryName;
          } else {
            obj.freshmarketerObject['city'] = geoLocation.cityName;
            obj.freshmarketerObject['state'] = geoLocation.regionName;
            obj.freshmarketerObject['country'] = geoLocation.countryName;
            obj.freshmarketerObject['zipcode'] = geoLocation.zipCode;
          }
        }
      } catch (e) { }
      break;
    case 'fping':
    case 'fteam':
    case 'fstatus':
    case 'fmarketer':
      obj.freshmarketerObject.custom_field[`cf_${product}firstreferrer`] = Cookie.get('fw_flu') || '';
      obj.freshmarketerObject.custom_field[`cf_${product}signupreferrer`] = window.location.href || '';
      if (product === 'fmarketer') obj.freshmarketerObject.custom_field['cf_freshmarketer_list'] = obj.freshmarketerObject.custom_field['cf_freshmarketer_list'] || 3755;
      break;
    case 'fconnect':
      obj.freshmarketerObject.custom_field['cf_fdeskaccounturl'] = $form.find('input[name="fdesk-helpdesk"]').val() + '.freshdesk.com';
      obj.freshmarketerObject.custom_field['cf_fsalesaccounturl'] = $form.find('input[name="fsales-helpdesk"]').val() + '.freshsales.io';
      break;
  }
  return SiteUtilities.freshmarketerPost(obj, false, $form, false);
};

const alohaForm = (classname, form) => {
  const $form = $(form);
  const product = $form.data('product');
  let productLabel = product;
  SiteUtilities.resetSignupPerformanceLog();
  localStorage.setItem('signupStartTime', new Date().toISOString());
  // control form section in sso signup
  const $formSection = $($form.parent('[data-form-section]'));
  const $submitButton = $form.find('.button');
  const $emailField = $form.find('input[name^="email"]');
  const email = $emailField.val() || null;
  const isEmailBusiness = email && !(email.includes('@gmail'));
  let apiDomain = $form.data('signup-url');
  const firstName = $form.find('.first-name-form').val() || null;
  const lastName = $form.find('.last-name-form').val() || null;
  const domain = $form.find('.domain-form').val() || null;
  const phone = $form.find('.phone-form').val() || null;
  const company = $form.find('.company-form').val() || null;
  const plan = $form.find('input[name="plan-id"]').val() || null;
  const remindEndPoint = $form.data('remind-path');
  const $miscPayload = $form.find('.aloha-misc-payload');
  const customCheckboxArray = [];
  const currentLang = $('body').attr('data-lang');
  $form.find('input[name="checkbox freshchat-whatsapp-signup-form"]:checked').each(function () {
    customCheckboxArray.push($(this).val());
  });
  const customCheckboxValues = customCheckboxArray.join(';');
  let growSumo = false;
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  let currentLoc = SiteUtilities.getCurrentLocation();
  const location = LocationUtilities.getGeoLocation();
  const productDesign = $form.hasClass('product-signupform');
  const planId = product === 'fchat' ? $form.data('plan-id') || 'msg' : $form.data('plan_id') || null;
  const deviceFingerPrintData = $('#talon6').val() ? $('#talon6').val() : JSON.stringify({ version: 6, status: -1 });

  if (planId && !$form.find('.fm-asset-id').val() && !$form.data('fm_asset_id')) {
    SiteUtilities.fwcrmAssetId($form, planId);
  }
  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || null;
  const compositeKey = SiteUtilities.getCompositeKey(email, fmAssetId, tacticId);
  const gclid = SiteUtilities.getGclId();
  const latestPageVisits = localStorage.getItem('latest_page_visits') || null;
  const companyIndustry = $form.find('.company-industry-form').val() || null;
  const website = $form.find('.website-form').val() || null;
  const jobLevel = $form.find('.job-level-form').val() || null;
  // In the process of signup optimization - The thank you page has been removed.
  const productHasNoThankYouPage = ['fdesk', 'fchat', 'fwcssuite'];
  const currencies = {
    US: 'USD',
    EU: 'EUR',
    GB: 'GBP',
    AU: 'AUD',
    IN: 'INR'
  };

  let fsCookie;
  try {
    fsCookie = freshsales.anonymous_id || '';
  } catch (exception) {
    SiteUtilities.log(
      'Freshsales session exception.',
      'warning',
      'submitHandlers.fsalesForm (fsCookie - Catch Exception)',
      0,
      exception
    );
  }

  if (productDesign) {
    $submitButton.addClass('button--product-disabled').attr('disabled', 'disabled');
    if (product === 'fworks') {
      fworksCrmSignupFormSuccess($form, true);
    }
    if (product === 'fwcrm' || product === 'fmarketer' || product === 'fsales') {
      fwCrmSignupFormSuccess($form, true);
    }
  } else {
    $submitButton.addClass('button--loading').attr('disabled', 'disabled');
  }

  let ipAddress;
  const country = location && location.countryName;
  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};

  if (currentReferrer && isExternalIframeSignup) {
    currentLoc = currentReferrer;
    if (sessionObj.current_session) {
      sessionObj.current_session.url = `${SiteUtilities.getCurrentLocation()}?first_referrer=${currentReferrer}`;
    }
  }
  if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
    const { simpleGeoLocation: { countryCode, countryName, country: { iso_code: isoCode } = {} } = {} } = sessionObj || {};
    if (sessionObj) {
      sessionObj.location = {
        country: {
          iso_code: isoCode || ''
        },
        ipAddress: '',
        countryCode: countryCode || '',
        countryName: countryName || ''
      };
      sessionObj.simpleGeoLocation = sessionObj.location;
      sessionObj.geoLocation = sessionObj.location;
    }
  } else {
    // Binding maxmind_session
    ipAddress = (location && location.ipAddress) ? location.ipAddress : null;
    sessionObj.location = LocationUtilities.getGeoLocation();
  }

  if (sessionObj) {
    // attach GA client ID (ga_client_id) in sessionObj
    sessionObj.ga_client_id = SiteUtilities.getCombinedGaClientId(gclid, compositeKey);
    // attach Google click ID (gclid) in sessionObj
    sessionObj.gclid = gclid;
  }

  const locale = SiteUtilities.getLocale(currentLang) || 'en-US';
  const postData = {
    user: {
      first_name: firstName,
      middle_name: null,
      last_name: lastName,
      email,
      phone,
      mobile: null,
      job_title: null,
      company_name: company,
      locale
    },
    organisation: {
      name: company,
      domain: company,
      locale
    },
    session_json: sessionObj,
    currency: null,
    plan: plan,
    first_referrer: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || currentLoc),
    first_landing_page: Cookie.get('fw_flu') || '',
    misc: {
      fs_cookie: fsCookie,
      composite_stitching_key: compositeKey,
      lead_source: 'Trial Signup',
      device_fingerprinting_info: deviceFingerPrintData
    }
  };

  const souceMedium = channelInfo.fetch();
  const utmMedium = SiteUtilities.getUtmMedium();

  if (souceMedium) {
    postData.misc.source_medium = souceMedium;
  }
  if (utmMedium) {
    postData.misc.utm_medium = utmMedium;
  }

  $miscPayload.each((index, ele) => {
    postData.misc[$(ele).data('key')] = $(ele).data('value');
  });

  const marketingCampaign = $form.find('[name="MarketingCampaign"],[name="Marketing Campaign"],[name="marketing_campaign"],[name="marketingcampaign"],[name="marketing campaign"]').data('custom-value');

  if (marketingCampaign) {
    postData.misc.marketing_campaign = marketingCampaign;
  }

  if (tacticId) {
    postData.misc.allocadia_tactic_id = tacticId;
  }

  if (fmAssetId) {
    postData.misc.allocadia_asset_id = fmAssetId;
  }

  if (customCheckboxValues) {
    postData.misc.preferred_channel_to_be_contacted = customCheckboxValues;
  }

  const shopifyJWT = SiteUtilities.getParameterByName('shopify_jwt');
  const JWTToken = $form.find('.google-jwt-token').val();
  const isGoogleSSO = !!(JWTToken && JWTToken.length);
  if (isGoogleSSO) {
    postData.user.oauth_details = {
      oauth_provider: 'google',
      token: JWTToken
    };
    if (email && !email.includes('@gmail.com')) localStorage.setItem('isSSOWithBusinessEmail', 'true');
  }
  const isFormPrefilled = !isGoogleSSO && sessionStorage.getItem('initial_form_details') === localStorage.getItem('form_details');

  if (sessionStorage.getItem('isPrefilledForm') !== 'false') {
    sessionStorage.setItem('isPrefilledForm', isFormPrefilled.toString());
  }
  SiteUtilities.storeSignupInitialLog();
  postData.misc.account_lang = SiteUtilities.getSignupEndpointLang(currentLang) || 'en';
  const cxProds = ['fwcssuite', 'fchat', 'fdesk', 'fcaller'];
  if (cxProds.includes(product)) {
    const ueObj = SiteUtilities.generateUEObj();
    postData.misc.session_enrichment = JSON.stringify(ueObj);
  }
  const pricingPlanType = SiteUtilities.getParameterByName('medium');
  switch (product) {
    case 'fdesk':
    case 'fwcssuite':
      postData.misc.account_name = company;
      growSumo = true;
      /** ** Conditionally add mandatory params for aloha internal environment ** **/
      if (window.location.href.includes('/signup-int')) {
        postData.cloud_type = window.location.href.includes('omnichannel') ? 'omnichannel' : 'messaging';
        postData.misc.account_domain = company;
        postData.misc.preferredDomain = company;
      }
      if (product === 'fwcssuite') {
        postData.cloud_type = 'cxsuite';
        postData.misc.plan_id = 'crm_cxsuite_enterprise_USD_Yearly';
      }

      if (apiDomain.includes('support360')) productLabel = 'fdeskomni';
      if (latestPageVisits) postData.misc.latest_page_visits = latestPageVisits;
      const isBusinessEmail = SiteUtilities.isBusinessEmail(email);
      if (!isBusinessEmail) {
        if (companyIndustry) postData.misc.cf_ls_company_industry = companyIndustry;
        if (website) postData.misc.website = website;
        if (jobLevel) postData.misc.cf_job_level = jobLevel;
      }
      break;

    case 'fping':
      postData.misc.application_url = $form.find('input[name^=url]').val() || null;
      break;

    case 'fworks':
      postData.misc.account_domain = company ? company.replace(/[^a-zA-Z0-9-]/g, '') : null;
      postData.misc.account_name = company;
      growSumo = true;
      break;

    case 'fstatus':
      postData.misc.website_url = $form.find('input[name^=url]').val() || null;
      break;

    case 'fteam':
      postData.misc.source = SiteUtilities.getParameterByName('utm_source');
      postData.misc.medium = SiteUtilities.getParameterByName('utm_medium');
      postData.misc.campaign = SiteUtilities.getParameterByName('utm_campaign');
      postData.misc.validate_duplicate = true;
      postData.misc.time_zone = sessionObj.time.tz_offset;
      postData.misc.gdpr_first_opt_in = ($form.find('input[name="send_promotions"]').is(':checked'));
      postData.misc.country = country;
      postData.misc.pre_visits = Cookie.get('fw_vi') || 0;
      const fteamSelectedCurrency = SiteUtilities.selectCountry(currencies, location.countryCode, location.countryName);
      const fteamCurrency = String(currencies[fteamSelectedCurrency]).toLocaleLowerCase();
      const fteamPlanValue = `enterprise_annual_${fteamCurrency}`;
      postData.misc.plan_id = fteamPlanValue;
      break;
    case 'fcaller':
    case 'fsales':
    case 'fsuccess':
    case 'fmarketer':
    case 'fchat':
    case 'fwcrm':
      const isShopifySignup = (shopifyJWT) || SiteUtilities.getParameterByName('att_referrer').includes('shopify');
      const isWoocommerceSignup = $form.data('marketplace-provider') === 'woocommerce' || SiteUtilities.getParameterByName('att_referrer').includes('woocommerce');
      let cloudType = product === 'fchat' ? $form.data('cloud-type') || 'freshdesk_messaging_cloud' : $form.data('cloud_type') || null;
      const selectedCurrency = SiteUtilities.selectCountry(currencies, location.countryCode, location.countryName);
      const currency = currencies[selectedCurrency];
      const planType = $form.data('plan-id') === 'growth' ? 'growth' : 'enterprise';
      let planvalue = `sales360_sales_${planType}_${currency}_Yearly`;
      const marketplaceProduct = $form.data('marketplace-product') || product;
      if (planId) {
        const planObj = {
          mc: {
            name: `sales360_marketing_${planType}_${currency}_Yearly`,
            productLabelKey: 'fmarketer'
          },
          c4l: {
            name: `sales360_clc_${planType}_${currency}_Yearly`,
            productLabelKey: 'fwcrm'
          },
          suite: {
            name: `sales360_clc_${planType}_${currency}_Yearly`,
            productLabelKey: 'fwcrm'
          },
          msg: {
            name: `crm_messaging_${planType}_${currency}_Yearly`,
            productLabelKey: 'fchat'
          }
        };

        if (planObj[planId]) {
          planvalue = planObj[planId].name;
          productLabel = planObj[planId].productLabelKey;
        }
      }
      if (isShopifySignup || isWoocommerceSignup) {
        const marketplacePlanValues = {
          fmarketer: {
            planId: `sales360_marketing_growth_${currency}_Yearly`,
            cloudType: 'marketing_cloud'
          },
          fdmessaging: {
            planId: `crm_messaging_growth_${currency}_Yearly`,
            cloudType: 'freshdesk_messaging_cloud'
          }
        };
        const planValues = marketplacePlanValues[marketplaceProduct];
        planvalue = planValues.planId;
        cloudType = planValues.cloudType;
      }
      if (product === 'fsuccess') {
        planvalue = `crm_fsu_enterprise_${currency}_Yearly`;
        cloudType = 'freshdesk_freshsuccess_cloud';
      } else if (product === 'fcaller') {
        planvalue = `crm_contact_center_enterprise_${currency}_Yearly`;
        cloudType = 'telephony';
      }
      if (cloudType) {
        postData.cloud_type = cloudType;
      }
      const attReferrer = localStorage.getItem('att_referrer');
      if (attReferrer) {
        postData.misc.att_referrer = `${attReferrer}_${marketplaceProduct}`;
      }
      if (shopifyJWT) {
        postData.user.oauth_details = {
          oauth_provider: 'shopify',
          token: shopifyJWT
        };
      }
      if (product === 'fchat') {
        if (postData.session_json.browser && postData.session_json.browser.version) {
          postData.session_json.browser.version = parseInt(postData.session_json.browser.version);
        }
      }
      if (product === 'fchat' || product === 'fcaller') {
        postData.misc.preferredDomain = company;
      }
      if (product === 'fsales') {
        postData.misc.free_growth_intent = planType === 'growth' ? 'Y' : 'N';
      }
      if (isWoocommerceSignup) {
        const woocommerceParams = [
          'utm_source',
          'utm_medium',
          'utm_campaign',
          'wp_php_version',
          'wp_version',
          'wp_store_url',
          'wp_store_name',
          'wp_user_name',
          'wp_user_email',
          'wp_gravatar',
          'first_name',
          'last_name'
        ].reduce((availableParams, param) => {
          const paramValue = SiteUtilities.getParameterByName(param);
          if (paramValue) {
            availableParams[param] = paramValue;
          }
          return availableParams;
        }, {});
        Object.assign(postData.misc, woocommerceParams);
        if (woocommerceParams.utm_source) {
          postData.misc.att_referrer = woocommerceParams.utm_source;
        }
      }
      postData.misc.plan_id = planvalue;
      postData.misc.account_domain = company ? company.replace(/[^a-zA-Z0-9-]/g, '') : null;
      postData.misc.account_name = company;
      if (latestPageVisits) postData.misc.latest_page_visits = latestPageVisits;
      growSumo = true;
      break;

    case 'fsurvey':
      postData.misc.company_name = company || null;
      break;
  }
  const selectedCurrency = SiteUtilities.selectCountry(currencies, location.countryCode, location.countryName);
  const prodCurrency = currencies[selectedCurrency];
  const miscPlanId = SiteUtilities.getMiscPlanId(product, prodCurrency, pricingPlanType);
  postData.misc.plan_id = miscPlanId || postData.misc.plan_id;

  /** **ONLY NEEDED IN STAGING STARTS** **/
  const currentLocation = window.location.href;
  if (currentLocation.includes('/signup-int')) {
    const apiURLFinal = new URL(apiDomain);
    apiURLFinal.host = 'aloha-int.freshid.io';
    apiDomain = apiURLFinal.href;
  }

  /** **ONLY NEEDED IN STAGING ENDS** **/
  // Handling growsumo data
  if (growSumo) {
    const gsdata = {
      first_name: firstName,
      email_id: email,
      domain_name: domain
    };
    localStorage.setItem('gsdata', JSON.stringify(gsdata));
  }

  const responseErrorHandler = (errorMsg, form) => {
    if (errorMsg) {
      errorMsg = typeof (errorMsg) === 'object' ? JSON.stringify(errorMsg) : errorMsg;
      if (errorMsg.includes('only one signup is allowed per email id')) {
        $('.login-trigger-button').trigger('click');

        if (remindEndPoint) {
          $submitButton.removeClass('button--loading').removeAttr('disabled');

          const $signupLoginModal = $('.signup-login-modal');
          $signupLoginModal.find('.email-reminder-button').on('click', function () {
            $(this).addClass('button--loading').attr('disabled', 'disabled');
            $.ajax({
              url: remindEndPoint + encodeURIComponent(email),
              type: 'GET',
              success: (response) => {
                $(this).removeClass('button--loading').removeAttr('disabled');
                $signupLoginModal.find('.form-field-container,.thank-you-card').addClass('active');
                $signupLoginModal.find('.thank-you-card').addClass('small-card');
              },
              error: () => {
                $(this).removeClass('button--loading').removeAttr('disabled').text('Retry');
              }
            });
          });
        }

        if (product === 'fteam') {
          $('.new-account-button').on('click', function () {
            postData.misc.validate_duplicate = false;
            $(this).addClass('button--loading product-specific');
            $.ajax({
              url: apiDomain,
              type: 'POST',
              data: JSON.stringify(postData),
              accept: 'application/json; charset=UTF-8',
              contentType: 'application/json; charset=UTF-8',
              dataType: 'json',
              success: (response, textStatus, jqXHR) => {
                const status = jqXHR.status;
                if ((status >= 200 && status < 300) || status === 304) {
                  fteamSignupFormSuccess($form, response, true);
                }
              },
              error: (jqXHR) => {
                $(this).removeClass('button--loading').removeAttr('disabled').text('Retry');
                failureLogData['message'] = `Aloha v2 Signup API call Failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText || 'jqXHR response text is undefined'}`;
                SiteUtilities.signupErrorLog(failureLogData, form);
              }
            });
          });
        }
      }
      if (errorMsg.includes('domain_taken') || errorMsg.includes('The Full domain has already been taken')) {
        $('.domain-taken-trigger-button').trigger('click');
      }
      if (errorMsg.includes('spam_email') || errorMsg.includes('invalid_email') || errorMsg.includes('blocked_domain')) {
        $('.login-spam-trigger-button').trigger('click');
      }
      if (product === 'fping' && errorMsg.includes('User already Registered')) {
        $('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">User already Registered</em>`);
      }
      if (product === 'fstatus' && errorMsg.includes('User already Registered')) {
        form.find('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">Please try using a different email address</em>`);
      }
      if (errorMsg.includes('company_name parameter length should not be more than 128')) {
        $('.company-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">Company length should not be more than 128 characters</em>`);
      }
      if (errorMsg.includes('Register using your work email')) {
        $('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">Register using your work email</em>`);
      }
      if (errorMsg.includes('Name cannot contain URLs or dots')) {
        $('.first-name-form').parent('.form-field').addClass('error').find('.error-wrapper').html(`<em id="email-error" class="error">Name cannot contain URLs or dots</em>`);
        $('.last-name-form').parent('.form-field').addClass('error');
      }
    }
    $submitButton.removeClass('button--loading').val('Retry').removeAttr('disabled');
  };

  const checkErrorValidity = errorMsg => {
    if (errorMsg) {
      errorMsg = typeof (errorMsg) === 'object' ? JSON.stringify(errorMsg) : errorMsg;
      if (
        errorMsg.includes('only one signup is allowed per email id') ||
        errorMsg.includes('domain_taken') ||
        errorMsg.includes('The Full domain has already been taken') ||
        errorMsg.includes('spam_email') ||
        errorMsg.includes('invalid_email') ||
        errorMsg.includes('blocked_domain') ||
        errorMsg.includes('User already Registered')
      ) {
        return false;
      }
    }
    return true;
  };

  const failureLogData = {
    email: email,
    source: 'FW.Submit.alohaForm',
    product: product,
    ip_address: ipAddress
  };

  const signupLogData = {
    email: email,
    source: 'FW.Submit.alohaForm',
    ip_address: ipAddress,
    type: 'signup',
    signup_payload_payload: postData,
    api_endpoint: apiDomain
  };

  localStorage.setItem('signupPerformanceLogData', JSON.stringify(signupLogData));
  localStorage.setItem('signupPerformanceProductLabel', productLabel);
  localStorage.setItem('signupPerformanceSignupUrl', currentLocation);

  if ($formSection.length) $formSection.css('pointer-events', 'none');

  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      company,
      phone,
      email,
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      country: country || '',
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: compositeKey
    }
  };
  postData.misc['collector_details'] = JSON.stringify(getCollectorPayload(freshmarketerData, $form));

  // let upstreamServiceTime = null;
  const params = {
    url: apiDomain,
    type: 'POST',
    data: JSON.stringify(postData),
    dataType: 'json',
    crossDomain: true,
    timeout: 100000, // Increase timeout to 100 seconds
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    success: (response, textStatus, jqXHR) => {
      response.composite_stitching_key = compositeKey;
      const status = jqXHR.status;
      const signupResponse = response['product_signup_response'];
      SiteUtilities.configureAssetId($form, product);

      // upstreamServiceTime = jqXHR.getResponseHeader('X-Envoy-Upstream-Service-Time');
      // upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);

      if ((status >= 200 && status < 300) || status === 304) {
        localStorage.setItem('alohaEndTime', new Date().toISOString());
        const bundleId = signupResponse.misc && signupResponse.misc.bundle_id ? signupResponse.misc.bundle_id : '';
        localStorage.setItem('bundleId', bundleId);
        channelInfo.destroy();
        switch (product) {
          case 'fchat':
            if (growSumo) {
              const accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : '';
              const domainLink = `fchat.${accountId}`;
              const gsdata = JSON.parse(localStorage.getItem('gsdata'));
              gsdata.domain_link = domainLink;
              localStorage.setItem('gsdata', JSON.stringify(gsdata));
            }
            fchatSignupFormSuccess($form, response, true);
            break;

          case 'fcaller':
            if (growSumo) SiteUtilities.setDomainLink(response);
            fcallerSignupFormSuccess($form, response, true);
            break;

          case 'fdesk':
            fdeskSignupFormSuccess($form, response, true);
            break;

          case 'fping':
            fpingSignupFormSuccess($form, response, true);
            break;

          case 'fworks':
            fworksCrmSignupForm($form, response, true);
            break;

          case 'fstatus':
            fstatusSignupFormSuccess($form, response, true);
            break;

          case 'fteam':
            fteamSignupFormSuccess($form, response, true);
            break;

          case 'fsurvey':
            fsurveySignupFormSuccess($form, response, true);
            break;

          case 'fwcrm':
          case 'fsales':
          case 'fsuccess':
          case 'fmarketer':
            if (growSumo) SiteUtilities.setDomainLink(response);
            fwCrmSignupForm($form, response, true);
            break;
          case 'fwcssuite':
            fwcssuiteSignupFormSuccess($form, response, true);
            break;
        }
        const formData = { company, email, firstName, lastName, phone };
        if (JWTToken && JWTToken.length) {
          GA4Utilities.googleSSOEvent('fwFormSubmit', (isEmailBusiness ? 'Business' : 'Generic'), 'Form Submission', classname, formData);
        } else if ($('[data-idp="GOOGLE"]').length) {
          GA4Utilities.googleSSOEvent('fwFormSubmit', 'Normal Signup', 'Normal Signup', classname, formData);
        } else if (shopifyJWT) {
          GA4Utilities.postGAEvent('fwFormSubmit', 'Shopify Signup Page', 'Shopify Signup Page', classname, 'Shopify Signup Page', formData);
        } else {
          GA4Utilities.fwFormSubmit(classname, formData);
        }
        localStorage.setItem('signupStatusCode', status);
        localStorage.setItem('signupStatusText', textStatus);
        localStorage.setItem('signupStatusMsg', 'Aloha v2 Signup API call successful');
        SiteUtilities.signupLog(signupLogData, form, status, { message: 'Aloha v2 Signup API call successful', response: `${jqXHR.responseText || 'jqXHR response text is undefined'}`, textStatus: `${textStatus}` });
      } else {
        localStorage.setItem('alohaEndTime', new Date().toISOString());
        const responseObject = {
          jqXHR,
          textStatus,
          response
        };
        $form.find('.button').removeClass('button--loading').attr('disabled', null);

        // sso signup section
        if ($formSection.length) {
          $formSection.css('pointer-events', 'auto');
          handleGoogleSingupErrHandler($formSection, JWTToken);
        }

        if (product === 'fworks') {
          fworksCrmSignupFormSuccess($form, false);
        }
        if (product === 'fwcrm' || product === 'fmarketer' || product === 'fsales') {
          fwCrmSignupFormSuccess($form, false);
        }
        SiteUtilities.classifyStatusCode(status, 'Aloha v2 Signup API call succeeded - Received Error Response', textStatus, responseObject);
        responseErrorHandler(jqXHR.responseText, $form);
        if (JWTToken && JWTToken.length) {
          GA4Utilities.googleSSOEvent('retry', 'Google SSO', 'Unsuccessful form submission');
        } else if ($('[data-idp="GOOGLE"]').length) {
          GA4Utilities.googleSSOEvent('retry', 'Normal Signup', 'Unsuccessful form submission');
        } else {
          GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
        }
        // Log valid error scenarios in db(filter out spam errors from getting logged)
        const errorValidity = checkErrorValidity(jqXHR.responseText);
        if (errorValidity) {
          failureLogData['message'] = `Aloha v2 Signup API call succeeded - Received Error Response. StatusCode: ${status}, Error: ${jqXHR.responseText || 'jqXHR response text is undefined'}`;
          SiteUtilities.signupErrorLog(failureLogData, form);
        }
        SiteUtilities.signupLog(signupLogData, form, status, { message: 'Aloha v2 Signup API call succeeded - Received Error Response', error: `${jqXHR.responseText || 'jqXHR response text is undefined'}`, textStatus: `${textStatus}` });
        SiteUtilities.signupPerformanceLog(signupLogData, productLabel, textStatus, status, 'Aloha v2 Signup API call succeeded - Received Error Response');
      }
    },
    error: (jqXHR, textStatus, err) => {
      localStorage.setItem('alohaEndTime', new Date().toISOString());
      // upstreamServiceTime = jqXHR.getResponseHeader('X-Envoy-Upstream-Service-Time');
      // upstreamServiceTime && localStorage.setItem('upstreamServiceDuration', upstreamServiceTime);
      const responseObject = {
        jqXHR,
        textStatus,
        err
      };
      $form.find('.button').removeClass('button--loading').attr('disabled', null);

      // sso signup section
      if ($formSection.length) {
        $formSection.css('pointer-events', 'auto');
        handleGoogleSingupErrHandler($formSection, JWTToken);
      }

      if (product === 'fworks') {
        fworksCrmSignupFormSuccess($form, false);
      }
      if (product === 'fwcrm' || product === 'fmarketer' || product === 'fsales') {
        fwCrmSignupFormSuccess($form, false);
      }
      SiteUtilities.classifyStatusCode(jqXHR.status, 'Aloha v2 Signup API call Failed', textStatus, responseObject);
      responseErrorHandler(jqXHR.responseText, $form);
      if (JWTToken && JWTToken.length) {
        GA4Utilities.googleSSOEvent('retry', 'Google SSO', 'Form Unsuccessful Submission');
      } else if ($('[data-idp="GOOGLE"]').length) {
        GA4Utilities.googleSSOEvent('retry', 'Normal Signup', 'Unsuccessful form submission');
      } else {
        GA4Utilities.signupRetryEvent('retry', 'Form Unsuccessful Submission', 'Retry option shown');
      }
      // Log valid error scenarios in db(filter out spam errors from getting logged)
      const errorValidity = checkErrorValidity(jqXHR.responseText);
      if (errorValidity) {
        failureLogData['message'] = `Aloha v2 Signup API call Failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText || 'jqXHR response text is undefined'}`;
        SiteUtilities.signupErrorLog(failureLogData, form);
      }
      SiteUtilities.signupLog(signupLogData, form, jqXHR.status, { message: 'Aloha v2 Signup API call Failed', error: `${jqXHR.responseText || 'jqXHR response text is undefined'}`, textStatus: `${textStatus}` });
      SiteUtilities.signupPerformanceLog(signupLogData, productLabel, textStatus, jqXHR.status, 'Aloha v2 Signup API call Failed');
    }
  };

  if (ipAddress) {
    params['headers'] = {
      'X-Forwarded-For': ipAddress
    };
  }

  localStorage.setItem('alohaStartTime', new Date().toISOString());

  // Add additional headers to signup int environment
  if (product === 'fdesk' && window.location.href.includes('/signup-int')) {
    const alohaBundle = 'freshdesk:omniint|freshchat:bots1|freshcaller:branch2';
    if (params['headers']) {
      params['headers']['x-fw-aloha-bundle'] = alohaBundle;
    } else {
      params['headers'] = { 'x-fw-aloha-bundle': alohaBundle };
    }
  }

  if ($form.find('.security-field-wrapper input').val()) {
    try {
      localStorage.setItem('isHoneyPotSignup', 'true');
      SiteUtilities.signupLog(signupLogData, form, null, { message: 'Spam Signup (Honey pot field has been filled)' }, true);
      SiteUtilities.signupPerformanceLog(signupLogData, productLabel, 'rejected', '400', 'Aloha v2 Signup API call not initiated - Received Honey pot Signup');
      setTimeout(() => {
        window.location.href = $form.data('redirect-spam') || $form.data('redirect');
      }, 2000);
    } catch (error) {
    }
  } else {
    $.ajax(params);
    // To improve the performance the next time we call that API, we should make a preflight (OPTIONS) request now.
    // Next 1 minute the browser will not make preflight request to check CORS policy.
    if (productHasNoThankYouPage.includes(product)) {
      SiteUtilities.makePreflightRequest('https://alfred.freshworks.com/v1/signup-performance-log');
      SiteUtilities.makePreflightRequest('https://alfred.freshworks.com/v1/kinesis-post');
    }
  }
};

export default {
  alohaForm
};
